import { Permission } from '../../components/Authorize/permissions';

export const DAY_CLICK_CREATE_EVENT = new Permission('calendar_day_createEvent', 'Allow to create new events');
// TODO check if EDIT_EVENT and EVENT_WRITE can be unified to one permission
export const EDIT_EVENT = new Permission('calendar_eventMenu_editEvent', 'Allow to edit event from calendar page');
export const DELETE_EVENT = new Permission('calendar_eventMenu_deleteEvent', 'Allow to delete events from calendar page');
